/* SC Mobile Menu v1.0 (Seed Cube)
   Moves the SC Mobile Menu section into the mobile drawer (#scMegaDrawer) and runs it:
   tabs, promo selection (dates), lazy images and promo videos, GA4 dataLayer events, theme editor support.
   No dependencies. The drawer itself is still opened and closed by mega-menu.js. */
(function () {
  'use strict';

  var MOBILE = window.matchMedia ? window.matchMedia('(max-width: 989px)') : null;
  var REDUCED = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var NUDGE_KEY = 'scmm2_nudged';
  var KL_REVISION = '2025-01-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function store(key, val) {
    try {
      if (val === undefined) return window.localStorage.getItem(key);
      if (val === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, val);
    } catch (e) { /* storage blocked */ }
    return null;
  }
  var seenPromos = {};
  var current = null;

  function push(menu, ev, params) {
    if (!menu || !menu.track) return;
    var data = { event: ev };
    for (var k in params) {
      if (Object.prototype.hasOwnProperty.call(params, k)) data[k] = params[k];
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }

  /* "YYYY-MM-DD" -> local midnight (start) or 23:59:59.999 (end). Anything else = no limit. */
  function dayEdge(value, isEnd) {
    var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(String(value || '').trim());
    if (!m) return null;
    var d = isEnd
      ? new Date(+m[1], +m[2] - 1, +m[3], 23, 59, 59, 999)
      : new Date(+m[1], +m[2] - 1, +m[3], 0, 0, 0, 0);
    return isNaN(d.getTime()) ? null : d.getTime();
  }

  function isLive(el, now) {
    var from = dayEdge(el.getAttribute('data-from'), false);
    var to = dayEdge(el.getAttribute('data-to'), true);
    if (from !== null && now < from) return false;
    if (to !== null && now > to) return false;
    return true;
  }

  function hydrate(scope) {
    if (!scope) return;
    var imgs = scope.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        var done = function () { img.classList.add('is-loaded'); };
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', function () {
          var box = img.parentNode;
          if (box) box.style.visibility = 'hidden';
        }, { once: true });
        if (img.getAttribute('data-srcset')) {
          img.setAttribute('srcset', img.getAttribute('data-srcset'));
          img.removeAttribute('data-srcset');
        }
        img.setAttribute('src', img.getAttribute('data-src'));
        img.removeAttribute('data-src');
        if (img.complete && img.naturalWidth) done();
      })(imgs[i]);
    }
    /* Promo videos: show the poster now; the video file itself loads only when it is about to play */
    var vids = scope.querySelectorAll('video[data-poster]');
    for (var v = 0; v < vids.length; v++) {
      if (vids[v].closest('[data-mm2-promo][hidden]')) continue;
      vids[v].setAttribute('poster', vids[v].getAttribute('data-poster'));
      vids[v].removeAttribute('data-poster');
    }
  }

  /* Muted loop autoplay, only for the open tab while the drawer is open and the page is visible.
     Reduced motion or Data Saver: poster only, the video file is never downloaded. */
  function videoAllowed() {
    if (REDUCED && REDUCED.matches) return false;
    var c = navigator.connection;
    if (c && c.saveData) return false;
    return true;
  }

  function Menu(root, drawer) {
    this.root = root;
    this.drawer = drawer;
    this.sectionId = root.getAttribute('data-section-id');
    this.track = root.getAttribute('data-track') !== 'false';
    this.animate = root.getAttribute('data-animate') !== 'false';
    this.remember = root.getAttribute('data-open') === 'last';
    this.nudge = root.getAttribute('data-nudge') === 'true';
    this.kpk = root.getAttribute('data-kpk') || '';
    this.defaultTab = root.getAttribute('data-default-tab') || '1';
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mm2-tab]'));
    this.activeTab = this.defaultTab;
    this.forcedPromo = null;
    this.isOpen = false;
    this.bind();
    this.pickPromos();
    this.initNotify();
  }

  Menu.prototype.panel = function (n) {
    return this.root.querySelector('[data-mm2-panel="' + n + '"]');
  };

  Menu.prototype.tabLabel = function (n) {
    var t = this.root.querySelector('[data-mm2-tab="' + n + '"]');
    return t ? t.getAttribute('data-mm2-label') : String(n);
  };

  /* Per slot: first promo that is in date wins. In the editor, a selected promo always shows. */
  Menu.prototype.pickPromos = function () {
    var now = Date.now();
    var forced = this.forcedPromo;
    var slots = this.root.querySelectorAll('[data-mm2-slot]');
    for (var i = 0; i < slots.length; i++) {
      var promos = slots[i].querySelectorAll('[data-mm2-promo]');
      var chosen = null;
      var j;
      if (forced) {
        for (j = 0; j < promos.length; j++) {
          if (promos[j].getAttribute('data-mm2-promo-id') === forced) chosen = promos[j];
        }
      }
      if (!chosen) {
        for (j = 0; j < promos.length; j++) {
          if (promos[j].hasAttribute('data-mm2-offmarket')) continue;
          if (isLive(promos[j], now)) { chosen = promos[j]; break; }
        }
      }
      for (j = 0; j < promos.length; j++) promos[j].hidden = promos[j] !== chosen;
      slots[i].hidden = !chosen;
    }
  };

  Menu.prototype.promoViews = function () {
    var panel = this.panel(this.activeTab);
    if (!panel || !this.isOpen) return;
    var promos = panel.querySelectorAll('[data-mm2-promo]');
    for (var i = 0; i < promos.length; i++) {
      var p = promos[i];
      if (p.hidden) continue;
      var id = p.getAttribute('data-mm2-promo-id');
      if (seenPromos[id]) continue;
      seenPromos[id] = true;
      push(this, 'menu_promo_view', {
        mm_tab: this.tabLabel(this.activeTab),
        mm_promo_id: id,
        mm_promo_name: p.getAttribute('data-mm2-name'),
        mm_promo_slot: p.getAttribute('data-mm2-slot-name'),
        mm_promo_style: p.getAttribute('data-mm2-style')
      });
    }
  };

  Menu.prototype.setTab = function (n, opts) {
    opts = opts || {};
    var panel = this.panel(n);
    if (!panel) return;
    var changed = String(n) !== String(this.activeTab);
    this.activeTab = String(n);
    for (var i = 0; i < this.tabs.length; i++) {
      var on = this.tabs[i].getAttribute('data-mm2-tab') === this.activeTab;
      this.tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      this.tabs[i].setAttribute('tabindex', on ? '0' : '-1');
      if (on && opts.focus) this.tabs[i].focus();
    }
    var panels = this.root.querySelectorAll('[data-mm2-panel]');
    for (var k = 0; k < panels.length; k++) panels[k].hidden = panels[k] !== panel;
    hydrate(panel);

    if (this.animate && (changed || opts.animate)) {
      var kids = panel.children;
      for (var c = 0; c < kids.length; c++) kids[c].style.setProperty('--mm2-i', Math.min(c, 10));
      panel.classList.remove('is-anim');
      void panel.offsetWidth;
      panel.classList.add('is-anim');
    }
    var body = this.root.parentNode;
    while (body && body !== document.body && body.scrollHeight <= body.clientHeight) body = body.parentNode;
    if (changed && body && body !== document.body) body.scrollTop = 0;

    if (changed && opts.user && this.isOpen) {
      push(this, 'menu_tab_view', { mm_tab: this.tabLabel(this.activeTab) });
    }
    this.promoViews();
    this.syncVideos();
  };

  Menu.prototype.syncVideos = function () {
    var vids = this.root.querySelectorAll('video[data-mm2-video]');
    if (!vids.length) return;
    var panel = this.panel(this.activeTab);
    var allow = this.isOpen && !document.hidden && videoAllowed();
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      var show = allow && panel && panel.contains(v) && !v.closest('[hidden]');
      if (show) {
        if (v.getAttribute('data-src')) {
          v.muted = true;
          v.setAttribute('src', v.getAttribute('data-src'));
          v.removeAttribute('data-src');
        }
        if (v.paused) {
          var p = v.play();
          if (p && p['catch']) p['catch'](function () { /* autoplay refused: the poster stays */ });
        }
      } else if (!v.paused) {
        v.pause();
      }
    }
  };

  Menu.prototype.onOpen = function () {
    this.isOpen = true;
    this.pickPromos();
    var tab = this.remember ? this.activeTab : this.defaultTab;
    this.setTab(tab, { animate: true });
    push(this, 'menu_open', { mm_tab: this.tabLabel(this.activeTab) });
    this.promoViews();
    this.runNudge();
  };

  /* Once per visit: lift the other tabs so people see there is more than one. */
  Menu.prototype.runNudge = function () {
    if (!this.nudge || this.tabs.length < 2 || (REDUCED && REDUCED.matches)) return;
    if (window.Shopify && window.Shopify.designMode) return;
    try {
      if (window.sessionStorage.getItem(NUDGE_KEY)) return;
      window.sessionStorage.setItem(NUDGE_KEY, '1');
    } catch (e) { /* storage blocked: nudge anyway */ }
    var bar = this.root.querySelector('.sc-mm2__tabs');
    if (!bar) return;
    var stop = function () { bar.classList.remove('is-nudge'); };
    setTimeout(function () {
      bar.classList.add('is-nudge');
      setTimeout(stop, 1700);
    }, 420);
    bar.addEventListener('pointerdown', stop, { once: true });
  };

  /* ---------- Register interest promos ---------- */

  function klPost(path, kpk, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + encodeURIComponent(kpk), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': KL_REVISION },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('Klaviyo ' + path + ' ' + r.status);
      return r;
    });
  }

  Menu.prototype.notifyParts = function (el) {
    return {
      intro: el.querySelector('[data-nt-intro]'),
      form: el.querySelector('[data-nt-form]'),
      done: el.querySelector('[data-nt-done]'),
      msg: el.querySelector('[data-nt-msg]'),
      sub: el.querySelector('[data-nt-done-sub]'),
      email: el.querySelector('input[name="email"]'),
      submit: el.querySelector('.sc-mm2__nt-submit'),
      open: el.querySelector('[data-nt-open]')
    };
  };

  Menu.prototype.notifyShow = function (el, state, choice) {
    var p = this.notifyParts(el);
    if (p.intro) p.intro.hidden = state !== 'intro';
    if (p.form) p.form.hidden = state !== 'form';
    if (p.done) p.done.hidden = state !== 'done';
    if (p.open) p.open.setAttribute('aria-expanded', state === 'form' ? 'true' : 'false');
    if (state === 'done' && p.sub) {
      var tpl = p.sub.getAttribute('data-tpl') || '';
      p.sub.textContent = tpl.replace(/\{choice\}/g, choice || '').replace(/\s{2,}/g, ' ').trim();
    }
  };

  Menu.prototype.initNotify = function () {
    var els = this.root.querySelectorAll('[data-mm2-notify]');
    for (var i = 0; i < els.length; i++) {
      if (els[i].getAttribute('data-mode') !== 'inline') { this.notifyShow(els[i], 'intro'); continue; }
      var saved = store('scmm2_nt_' + els[i].getAttribute('data-interest'));
      this.notifyShow(els[i], saved !== null && saved !== undefined ? 'done' : 'intro', saved || '');
    }
  };

  Menu.prototype.notifySubmit = function (el) {
    var self = this;
    var p = this.notifyParts(el);
    var email = (p.email.value || '').trim();
    var picked = el.querySelector('input[name="choice"]:checked');
    var choice = picked ? picked.value : '';
    var list = el.getAttribute('data-list');
    var interest = el.getAttribute('data-interest');
    var evName = el.getAttribute('data-event') || 'Registered Interest';
    var name = el.getAttribute('data-mm2-name');
    p.msg.textContent = '';
    if (!EMAIL_RE.test(email)) {
      p.email.setAttribute('aria-invalid', 'true');
      p.msg.textContent = el.getAttribute('data-msg-invalid') || 'Enter a valid email address.';
      p.email.focus();
      return;
    }
    p.email.removeAttribute('aria-invalid');
    if (!this.kpk) {
      p.msg.textContent = 'Sign-up is not connected yet.';
      if (window.console) console.warn('[SC Mobile Menu] Add the Klaviyo public key in the section settings.');
      return;
    }
    var label = p.submit.textContent;
    p.submit.disabled = true;
    p.submit.textContent = el.getAttribute('data-msg-sending') || 'Sending...';
    var props = { interest_key: interest, interest_choice: choice, interest_source: 'mobile_menu' };
    var jobs = [];
    if (list) {
      jobs.push(klPost('subscriptions', this.kpk, {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Mobile menu: ' + interest,
            profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      }));
    }
    var ev = klPost('events', this.kpk, {
      data: {
        type: 'event',
        attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: evName } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        }
      }
    });
    if (!list) jobs.push(ev);
    else ev['catch'](function () {});
    Promise.all(jobs).then(function () {
      store('scmm2_nt_' + interest, choice);
      try { if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: email }); } catch (e) {}
      p.email.value = '';
      self.notifyShow(el, 'done', choice);
      if (p.done) p.done.focus();
      push(self, 'menu_notify_submit', { mm_tab: self.tabLabel(self.activeTab), mm_promo_name: name, mm_choice: choice, mm_interest: interest });
    })['catch'](function (err) {
      p.msg.textContent = el.getAttribute('data-msg-failed') || 'That did not go through. Check your connection and try again.';
      if (window.console) console.warn('[SC Mobile Menu]', err);
      push(self, 'menu_notify_error', { mm_promo_name: name, mm_interest: interest });
    }).then(function () {
      p.submit.disabled = false;
      p.submit.textContent = label;
    });
  };

  /* Opens a Klaviyo popup or flyout form by ID (klaviyo.js, with the _klOnsite queue as fallback). */
  function openKlaviyoForm(id) {
    try {
      if (window.klaviyo && typeof window.klaviyo.openForm === 'function') { window.klaviyo.openForm(id); return true; }
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', id]);
      return true;
    } catch (e) {
      if (window.console) console.warn('[SC Mobile Menu] Klaviyo form ' + id + ' did not open', e);
      return false;
    }
  }

  function closeDrawer() {
    var burger = document.getElementById('sc-mega-menu-burger');
    if (!burger) return;
    burger.checked = false;
    burger.dispatchEvent(new Event('change', { bubbles: true }));
  }

  Menu.prototype.onClose = function () {
    this.isOpen = false;
    if (this.countryClose) this.countryClose();
    this.syncVideos();
  };

  Menu.prototype.bind = function () {
    var self = this;
    var root = this.root;

    root.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-nt-form]');
      if (!form) return;
      e.preventDefault();
      self.notifySubmit(form.closest('[data-mm2-notify]'));
    });

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-mm2-close]')) {
        closeDrawer();
        return;
      }
      var nt = e.target.closest('[data-mm2-notify]');
      if (nt && root.contains(nt)) {
        var kf = e.target.closest('[data-nt-kform]');
        var ln = e.target.closest('[data-nt-link]');
        if (kf || ln) {
          push(self, 'menu_promo_click', {
            mm_tab: self.tabLabel(self.activeTab),
            mm_promo_id: nt.getAttribute('data-mm2-promo-id'),
            mm_promo_name: nt.getAttribute('data-mm2-name'),
            mm_promo_slot: nt.getAttribute('data-mm2-slot-name'),
            mm_promo_style: 'notify',
            mm_url: kf ? 'klaviyo-form:' + kf.getAttribute('data-nt-kform') : (ln.getAttribute('href') || '')
          });
          if (kf) openKlaviyoForm(kf.getAttribute('data-nt-kform'));
          return;
        }
        if (e.target.closest('[data-nt-open]')) {
          self.notifyShow(nt, 'form');
          push(self, 'menu_promo_click', {
            mm_tab: self.tabLabel(self.activeTab),
            mm_promo_id: nt.getAttribute('data-mm2-promo-id'),
            mm_promo_name: nt.getAttribute('data-mm2-name'),
            mm_promo_slot: nt.getAttribute('data-mm2-slot-name'),
            mm_promo_style: 'notify',
            mm_url: ''
          });
          var first = nt.querySelector('input[name="choice"]:checked') || nt.querySelector('input[name="email"]');
          if (first) first.focus({ preventScroll: true });
          var f = nt.querySelector('[data-nt-form]');
          if (f && f.scrollIntoView) f.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        } else if (e.target.closest('[data-nt-again]')) {
          store('scmm2_nt_' + nt.getAttribute('data-interest'), null);
          self.notifyShow(nt, 'form');
          var em = nt.querySelector('input[name="email"]');
          if (em) em.focus();
        }
        return;
      }
      var tab = e.target.closest('[data-mm2-tab]');
      if (tab && root.contains(tab)) {
        if (self.countryClose) self.countryClose();
        self.setTab(tab.getAttribute('data-mm2-tab'), { user: true });
        return;
      }
      var promo = e.target.closest('[data-mm2-promo]');
      if (promo && root.contains(promo)) {
        push(self, 'menu_promo_click', {
          mm_tab: self.tabLabel(self.activeTab),
          mm_promo_id: promo.getAttribute('data-mm2-promo-id'),
          mm_promo_name: promo.getAttribute('data-mm2-name'),
          mm_promo_slot: promo.getAttribute('data-mm2-slot-name'),
          mm_promo_style: promo.getAttribute('data-mm2-style'),
          mm_url: promo.getAttribute('href') || ''
        });
        return;
      }
      var item = e.target.closest('[data-mm2-item]');
      if (item && root.contains(item)) {
        push(self, 'menu_click', {
          mm_tab: self.tabLabel(self.activeTab),
          mm_type: item.getAttribute('data-mm2-type'),
          mm_item: item.getAttribute('data-mm2-name'),
          mm_position: parseInt(item.getAttribute('data-mm2-pos') || '0', 10),
          mm_url: item.getAttribute('href') || ''
        });
      }
    });

    var list = root.querySelector('[role="tablist"]');
    if (list) {
      list.addEventListener('keydown', function (e) {
        var keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
        if (keys.indexOf(e.key) === -1) return;
        var idx = 0;
        for (var i = 0; i < self.tabs.length; i++) {
          if (self.tabs[i].getAttribute('data-mm2-tab') === self.activeTab) idx = i;
        }
        var last = self.tabs.length - 1;
        if (e.key === 'ArrowRight') idx = idx === last ? 0 : idx + 1;
        if (e.key === 'ArrowLeft') idx = idx === 0 ? last : idx - 1;
        if (e.key === 'Home') idx = 0;
        if (e.key === 'End') idx = last;
        e.preventDefault();
        self.setTab(self.tabs[idx].getAttribute('data-mm2-tab'), { user: true, focus: true });
      });
    }

    this.initCountry();
    this.initBird();
  };

  /* ---------- Bird search block ----------
     Same species list and matching as the Bird Match Quiz (assets/bird-data.json, shared cache).
     The list loads on first focus, not on page load. A result opens the quiz with ?species_breed=,
     which skips the quiz's species question. Results are plain links, tracked by the menu_click handler. */
  var BIRD_BROAD = ['macaw', 'cockatoo', 'parrot', 'finch', 'corella', 'pigeon', 'rosella'];
  var BIRD_SMALL_MAX_G = 250;
  var BIRD_TOO_LARGE_G = 2500;
  var birdData = null;
  function loadBirds(src) {
    if (!birdData) {
      birdData = fetch(src, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('bird data ' + r.status); return r.json(); })
        .then(function (d) {
          var rev = {};
          for (var al in d.aliases || {}) {
            if (Object.prototype.hasOwnProperty.call(d.aliases, al)) (rev[d.aliases[al]] = rev[d.aliases[al]] || []).push(al);
          }
          d.rev = rev;
          return d;
        });
      birdData.catch(function () { birdData = null; });
    }
    return birdData;
  }
  function birdNorm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[\u2019']/g, '').replace(/[^a-z0-9& -]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function birdTitle(s) {
    return String(s || '').replace(/(^|[\s-])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }).replace(/\s(And|Of|The)\s/g, function (m) { return m.toLowerCase(); });
  }
  function birdPlural(s) {
    if (/(s|x|ch|sh)$/i.test(s)) return s + 'es';
    if (/[^aeiou]y$/i.test(s)) return s.slice(0, -1) + 'ies';
    return s + 's';
  }
  function birdBroad(d, q) {
    var n = birdNorm(q);
    if (!n) return '';
    var a = d.aliases[n] || n;
    if (BIRD_BROAD.indexOf(a) >= 0 && d.suggestions && d.suggestions[a]) return a;
    if (n.slice(-1) === 's') {
      var sing = d.aliases[n.slice(0, -1)] || n.slice(0, -1);
      if (BIRD_BROAD.indexOf(sing) >= 0 && d.suggestions && d.suggestions[sing]) return sing;
    }
    return '';
  }
  /* Same rules and ranking as search() in sc-bird-quiz.js */
  function birdFind(d, q) {
    var n = birdNorm(q);
    if (n.length < 2) return [];
    var toks = n.split(' ');
    var out = [];
    Object.keys(d.species).forEach(function (k) {
      if (BIRD_BROAD.indexOf(k) >= 0) return;
      var kn = birdNorm(k);
      var hit = toks.every(function (tk) { return kn.indexOf(tk) >= 0; });
      var viaAlias = '';
      if (!hit) {
        var als = d.rev[k] || [];
        for (var i = 0; i < als.length; i++) {
          if (toks.every(function (tk) { return als[i].indexOf(tk) >= 0; })) { hit = true; viaAlias = als[i]; break; }
        }
      }
      if (!hit) return;
      var score = kn.indexOf(n) === 0 ? 0 : (kn.indexOf(' ' + n) >= 0 || kn.indexOf('-' + n) >= 0) ? 1 : kn.indexOf(n) > 0 ? 2 : (viaAlias ? 3 : 2.5);
      out.push({ key: k, score: score, alias: viaAlias });
    });
    out.sort(function (a, b) { return a.score - b.score || a.key.localeCompare(b.key); });
    return out.slice(0, 6);
  }
  function quizLink(base, key, bq) {
    return base + (base.indexOf('?') >= 0 ? '&' : '?') + (key ? 'species_breed=' + encodeURIComponent(key) + '&' : '') + 'bq=' + bq;
  }

  Menu.prototype.initBird = function () {
    var self = this;
    var boxes = this.root.querySelectorAll('[data-mm2-bird]');
    Array.prototype.forEach.call(boxes, function (box) {
      var q = box.querySelector('[data-mm2-bird-q]');
      var list = box.querySelector('[data-mm2-bird-list]');
      var st = box.querySelector('[data-mm2-bird-st]');
      var clear = box.querySelector('[data-mm2-bird-clear]');
      if (!q || !list) return;
      var src = box.getAttribute('data-src');
      var quiz = box.getAttribute('data-quiz') || '/pages/quiz';
      var txt = function (k, d) { return box.getAttribute('data-' + k) || d; };
      var seq = 0;

      function el(tag, cls, text) {
        var n = document.createElement(tag);
        if (cls) n.className = cls;
        if (text != null) n.textContent = text;
        return n;
      }
      function option(href, type, name, pos, title, sub, pill) {
        var li = el('li');
        var a = el('a', 'sc-mm2__bird-opt');
        a.href = href;
        a.setAttribute('data-mm2-item', '');
        a.setAttribute('data-mm2-type', type);
        a.setAttribute('data-mm2-name', name);
        a.setAttribute('data-mm2-pos', String(pos));
        var t = el('span', 'sc-mm2__bird-txt');
        t.appendChild(el('span', 'sc-mm2__bird-name', title));
        if (sub) t.appendChild(el('span', 'sc-mm2__bird-sub', sub));
        a.appendChild(t);
        if (pill) a.appendChild(el('span', 'sc-mm2__bird-size', pill));
        li.appendChild(a);
        return li;
      }
      function sizeText(d, key) {
        var w = d.species[key];
        if (typeof w !== 'number') return '';
        if (w > BIRD_TOO_LARGE_G) return txt('xl', 'Very large bird: check fit');
        return w < BIRD_SMALL_MAX_G ? txt('small', 'Small Seed Cube') : txt('large', 'Large Seed Cube');
      }
      function status(msg) { if (st) st.textContent = msg; }
      function show(nodes) {
        list.textContent = '';
        nodes.forEach(function (n) { list.appendChild(n); });
        list.hidden = !nodes.length;
      }
      function noneLink(term) {
        return option(quizLink(quiz, '', 'menu_search_none'), 'bird_search_none', term.slice(0, 40), 0, txt('none', 'Not on our list? Take the quiz'), '', '');
      }
      function render() {
        var term = q.value;
        if (clear) clear.hidden = !term;
        if (birdNorm(term).length < 2) { show([]); status(''); return; }
        var mine = ++seq;
        loadBirds(src).then(function (d) {
          if (mine !== seq) return;
          var nodes = [];
          var bk = birdBroad(d, term);
          if (bk) {
            var kinds = (d.suggestions[bk] || []).length;
            nodes.push(option(quizLink(quiz, bk, 'menu_search'), 'bird_search', bk, 1, birdTitle(birdPlural(bk)), txt('kinds', '{n} kinds. Pick yours').replace('{n}', kinds), ''));
          }
          birdFind(d, term).forEach(function (m) {
            if (m.key === bk) return;
            nodes.push(option(quizLink(quiz, m.key, 'menu_search'), 'bird_search', m.key, nodes.length + 1, birdTitle(m.key), m.alias ? 'Also called ' + birdTitle(m.alias) : '', sizeText(d, m.key)));
          });
          if (!nodes.length) {
            show([noneLink(term)]);
            status(txt('none', 'Not on our list? Take the quiz'));
            return;
          }
          show(nodes);
          status(nodes.length + (nodes.length === 1 ? ' match' : ' matches'));
        }, function () {
          if (mine !== seq) return;
          show([noneLink(term)]);
          status('');
        });
      }
      function links() { return Array.prototype.slice.call(list.querySelectorAll('a')); }

      /* Also hand the bird to the quiz through sessionStorage: the theme editor preview drops query strings from links. */
      list.addEventListener('click', function (e) {
        var a = e.target.closest('a.sc-mm2__bird-opt');
        if (!a) return;
        try {
          if (a.getAttribute('data-mm2-type') === 'bird_search') {
            window.sessionStorage.setItem('scbq_preset', JSON.stringify({ k: a.getAttribute('data-mm2-name'), bq: 'menu_search', t: Date.now() }));
          } else {
            window.sessionStorage.removeItem('scbq_preset');
          }
        } catch (err) { /* storage blocked: the link still carries the bird */ }
      });
      q.addEventListener('focus', function () { loadBirds(src).catch(function () {}); });
      q.addEventListener('input', render);
      q.addEventListener('keydown', function (e) {
        var ls = links();
        if (e.key === 'ArrowDown' && ls.length) { e.preventDefault(); ls[0].focus(); }
        else if (e.key === 'Enter') {
          e.preventDefault();
          if (ls.length) ls[0].click();
        } else if (e.key === 'Escape' && q.value) {
          e.preventDefault();
          e.stopPropagation();
          q.value = '';
          render();
        }
      });
      list.addEventListener('keydown', function (e) {
        var ls = links();
        var i = ls.indexOf(document.activeElement);
        if (i < 0) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); (ls[i + 1] || ls[i]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); if (i === 0) q.focus(); else ls[i - 1].focus(); }
        else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); q.focus(); }
      });
      if (clear) {
        clear.addEventListener('click', function () {
          q.value = '';
          render();
          q.focus();
        });
      }
    });
  };

  /* ---------- Country and currency sheet ----------
     The footer button opens a sheet above the footer with a search box and the country list,
     drawn in the menu font (a native select shows the phone's system list). The list is built
     from JSON on first open, so the page carries no option markup. Picking a country submits
     Shopify's localization form, same as before. */

  function fold(str) {
    return String(str || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/&/g, 'and');
  }

  /* Shopify sends country names HTML-encoded ("South Georgia &amp; ..."). A textarea decodes
     entities without running anything. */
  var decoder = null;
  function decode(str) {
    decoder = decoder || document.createElement('textarea');
    decoder.innerHTML = String(str || '');
    return decoder.value;
  }

  Menu.prototype.initCountry = function () {
    var self = this;
    var root = this.root;
    var btn = root.querySelector('[data-mm2-loc-open]');
    var sheet = root.querySelector('[data-mm2-loc-sheet]');
    var input = root.querySelector('[data-mm2-country]');
    if (!btn || !sheet || !input) return;
    var q = sheet.querySelector('[data-mm2-loc-q]');
    var list = sheet.querySelector('[data-mm2-loc-list]');
    var empty = sheet.querySelector('[data-mm2-loc-empty]');
    var data = null;
    var items = [];
    var locked = null;

    function build() {
      if (data) return;
      try { data = JSON.parse(sheet.querySelector('[data-mm2-loc-data]').textContent) || []; } catch (e) { data = []; }
      var cur = input.value;
      var html = '';
      for (var i = 0; i < data.length; i++) {
        var c = data[i];
        var on = c[0] === cur;
        html += '<li><button type="button" class="sc-mm2__locitem" data-iso="' + c[0] + '"' + (on ? ' aria-current="true"' : '') + '>' +
          '<span class="sc-mm2__locname"></span><span class="sc-mm2__loccur"></span>' +
          (on ? '<svg class="sc-mm2__loctick" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M3 8.5l3 3 7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' : '') +
          '</button></li>';
      }
      list.innerHTML = html;
      var btns = list.querySelectorAll('.sc-mm2__locitem');
      for (var j = 0; j < btns.length; j++) {
        /* textContent, not innerHTML: names come from Shopify but are never parsed as markup */
        var nm = decode(data[j][1]);
        btns[j].firstChild.textContent = nm;
        btns[j].children[1].textContent = data[j][2] + ' ' + decode(data[j][3]);
        items.push({ li: btns[j].parentNode, key: ' ' + fold(nm).replace(/[^a-z0-9]+/g, ' '), iso: data[j][0].toLowerCase(), cur: data[j][2].toLowerCase() });
      }
    }

    function filter() {
      /* Matches the start of any word in the name ("zea" finds New Zealand, "aland" does not),
         the 2-letter country code (NZ) or, from 3 letters, the currency code (EUR). Many countries
         check out in AUD, so "au" must not list them all. */
      var v = fold(q.value).replace(/[^a-z0-9]+/g, ' ').trim();
      var shown = 0;
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        var hit = !v || it.key.indexOf(' ' + v) !== -1 || it.iso === v || (v.length >= 3 && it.cur.indexOf(v) === 0);
        it.li.hidden = !hit;
        if (hit) shown++;
      }
      empty.hidden = shown !== 0;
      list.scrollTop = 0;
    }

    function size() {
      var tabs = root.querySelector('.sc-mm2__tabs');
      var foot = btn.closest('.sc-mm2__foot');
      if (!foot) return;
      var top = tabs ? tabs.getBoundingClientRect().bottom : 0;
      var h = Math.round(foot.getBoundingClientRect().top - top);
      sheet.style.setProperty('--mm2-loc-h', Math.max(h, 220) + 'px');
    }

    function scroller() {
      var b = root.parentNode;
      while (b && b !== document.body && !/(auto|scroll)/.test(getComputedStyle(b).overflowY)) b = b.parentNode;
      return b && b !== document.body ? b : null;
    }

    self.countryClose = function (opts) {
      if (sheet.hidden) return;
      sheet.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      if (locked) { locked.style.overflowY = ''; locked = null; }
      if (opts && opts.focus) btn.focus();
    };

    function open() {
      build();
      q.value = '';
      filter();
      size();
      sheet.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      /* Stop the menu behind from scrolling while the list is open */
      locked = scroller();
      if (locked) locked.style.overflowY = 'hidden';
      var cur = list.querySelector('[aria-current="true"]');
      if (cur) list.scrollTop = Math.max(0, cur.parentNode.offsetTop - list.clientHeight / 2 + cur.offsetHeight / 2);
      /* Keyboard and mouse: straight into the search box. Touch: no keyboard pop-up until they tap it. */
      if (window.matchMedia && window.matchMedia('(pointer: fine)').matches) q.focus({ preventScroll: true });
      push(self, 'menu_click', { mm_tab: self.tabLabel(self.activeTab), mm_type: 'country_open', mm_item: input.value, mm_position: 0, mm_url: '' });
    }

    btn.addEventListener('click', function () {
      if (sheet.hidden) open();
      else self.countryClose({ focus: true });
    });

    q.addEventListener('input', filter);

    sheet.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      e.stopPropagation();
      if (q.value) { q.value = ''; filter(); q.focus(); }
      else self.countryClose({ focus: true });
    });

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-mm2-loc-close]')) { self.countryClose({ focus: true }); return; }
      var it = e.target.closest('.sc-mm2__locitem');
      if (!it) return;
      var iso = it.getAttribute('data-iso');
      push(self, 'menu_click', { mm_tab: self.tabLabel(self.activeTab), mm_type: 'country', mm_item: iso, mm_position: 0, mm_url: '' });
      if (iso === input.value) { self.countryClose({ focus: true }); return; }
      input.value = iso;
      it.setAttribute('aria-busy', 'true');
      if (input.form) input.form.submit();
    });

    window.addEventListener('resize', function () { if (!sheet.hidden) size(); });
  };

  /* ---------- Mounting ---------- */

  function drawerEl() { return document.getElementById('scMegaDrawer'); }

  function mount() {
    var drawer = drawerEl();
    var body = drawer && drawer.querySelector('.sc-mega-menu__drawer-body');
    if (!body) return null;
    var src = document.querySelector('.sc-mm2[data-sc-mm2]:not([data-mm2-mounted])');
    if (!src) return current;

    var host = body.querySelector('[data-sc-mm2-mount]');
    if (!host) {
      host = document.createElement('div');
      host.className = 'sc-mega-menu__mm2-mount';
      host.setAttribute('data-sc-mm2-mount', '');
      body.insertBefore(host, body.firstChild);
    }
    var old = host.querySelectorAll('.sc-mm2[data-mm2-mounted]');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);

    host.appendChild(src);
    src.setAttribute('data-mm2-mounted', '');
    src.hidden = false;
    drawer.classList.add('sc-mm2-on');
    document.documentElement.classList.add('sc-mm2-active');
    current = new Menu(src, drawer);
    if (drawer.classList.contains('is-open')) current.onOpen();
    return current;
  }

  function unmount(id) {
    var drawer = drawerEl();
    var node = drawer && drawer.querySelector('.sc-mm2[data-section-id="' + id + '"]');
    if (!node) return;
    node.parentNode.removeChild(node);
    drawer.classList.remove('sc-mm2-on');
    document.documentElement.classList.remove('sc-mm2-active');
    current = null;
  }

  function watchDrawer() {
    var drawer = drawerEl();
    if (!drawer || !window.MutationObserver) return;
    var wasOpen = drawer.classList.contains('is-open');
    new MutationObserver(function () {
      var open = drawer.classList.contains('is-open');
      if (open === wasOpen) return;
      wasOpen = open;
      if (!current) return;
      if (open) current.onOpen();
      else current.onClose();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function openDrawer() {
    var drawer = drawerEl();
    var burger = document.getElementById('sc-mega-menu-burger');
    if (!drawer || !burger || drawer.classList.contains('is-open')) return;
    if (MOBILE && !MOBILE.matches) return;
    burger.checked = true;
    burger.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ---------- Theme editor ---------- */

  function editorEvents() {
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target || !e.target.querySelector('.sc-mm2[data-sc-mm2]')) return;
      var tab = current ? current.activeTab : null;
      var m = mount();
      if (m && tab) m.setTab(tab);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      if (e.detail && e.detail.sectionId) unmount(e.detail.sectionId);
    });

    document.addEventListener('shopify:block:select', function (e) {
      if (!current || !e.detail || e.detail.sectionId !== current.sectionId) return;
      var el = e.target;
      if (!el || !current.root.contains(el)) return;
      var panel = el.closest('[data-mm2-panel]');
      current.forcedPromo = el.hasAttribute('data-mm2-promo') ? el.getAttribute('data-mm2-promo-id') : null;
      current.pickPromos();
      openDrawer();
      if (panel) current.setTab(panel.getAttribute('data-mm2-panel'));
      else current.syncVideos();
      setTimeout(function () {
        if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
      }, 320);
    });

    document.addEventListener('shopify:block:deselect', function () {
      if (!current) return;
      current.forcedPromo = null;
      current.pickPromos();
      current.syncVideos();
    });

    document.addEventListener('shopify:section:select', function (e) {
      if (current && e.detail && e.detail.sectionId === current.sectionId) openDrawer();
    });
  }

  function init() {
    mount();
    watchDrawer();
    document.addEventListener('visibilitychange', function () { if (current) current.syncVideos(); });
    if (window.Shopify && window.Shopify.designMode) editorEvents();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
